/**
 * @author Luke Brandon Farrell
 * @description Stores and initializes all images in the application.
 */

export const images = {
  your_team: require("./your-team@2x.png"),
  top_team: require("./top-team@2x.png"),
  the_company: require("./the-company@2x.png"),
  yodha_logo:
    "https://yodhaprodstorage.blob.core.windows.net/yodhapublicimages/logo512.png",
};
